const stickyBar = document.querySelector(".sticky-bar");
const stickyBarForm = document.querySelector(".sticky-bar-form");
const formBtn = document.querySelector('.product-single__form');

const addToCart = async (event) => {
	event.preventDefault();
	const productId = event.target.dataset.productId;

	let formData = {
		items: [
			{
				id: productId,
				quantity: 1,
			},
		],
	};

	fetch(window.Shopify.routes.root + "cart/add.js", {
		method: "POST",
		headers: {
			"Content-Type": "application/json",
		},
		body: JSON.stringify(formData),
	})
		.then((response) => {
			return response.json();
		})
		.catch((error) => {
			console.error("Error:", error);
		})
		.then(() => new theme.CartDrawer().open());
};

const renderDOM = async (event) => {
	const target = event.target;
	const productHandle = target.dataset.productHandle;

	const res = await fetch(
		`${Shopify.routes.root}products/${productHandle}?variant=${target.value}`
	);
	const html = await res.text();
	const newDom = new DOMParser().parseFromString(html, "text/html");

	document.querySelector(".product-block--price").innerHTML =
		newDom.querySelector(".product-block--price").innerHTML;

	const selectedOption = target.options[target.selectedIndex];
	const titleOption = selectedOption.getAttribute("title");

	const variantInputs = document.querySelectorAll(".variant-input label");

	if (variantInputs) {
		variantInputs.forEach((variant) => {
			if (variant.dataset.value === titleOption) {
				variant.click();
			}
		});
	}

	target.closest(".sticky-bar-inner").innerHTML =
		newDom.querySelector(".sticky-bar-inner").innerHTML;
};

const hideStickyBar = (stickyElement, target) => {
	const header = document.querySelector('header');
	const buttonRect = target?.getBoundingClientRect();
	const headerRect = header.getBoundingClientRect();
	const headerHeight = headerRect.height;

	if (buttonRect.bottom >= headerHeight && buttonRect.top <= window.innerHeight) {
        stickyElement?.classList.contains('visibility') && stickyElement?.classList.remove('visibility');
    } else {
        !stickyElement?.classList.contains('visibility') && stickyElement?.classList.add('visibility');
    }
};

document.querySelector(".sticky-bar-form")?.addEventListener("change", renderDOM);

stickyBar?.addEventListener("click", (event) => {
	const target = event.target;
	if (target.closest(".add-to-cart")) addToCart(event);
});

window.addEventListener("scroll", () => hideStickyBar(stickyBarForm, formBtn));
